import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import TaskList from './TaskList';
import MilestoneProgress from './MilestoneProgress';
import MilestoneInfo from './MilestoneInfo';
import styles from './MilestonesView.m.sass';
import MilestoneCompletionModal from './MilestoneCompletionModal';
var MilestonesView = function MilestonesView(_ref) {
  var state = _ref.state;
  if (!state) return null;
  if (state.milestones.length === 0) return null;
  var lists = state.taskLists.filter(function (list) {
    return list.tasks.length > 0 || list.isDesignee;
  });
  var locked = !state.canCompleteMilestone;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.progress
  }, /*#__PURE__*/React.createElement(MilestoneProgress, {
    totalCount: locked ? 1 : state.tasksCount,
    completedCount: locked ? 0 : state.completedTasksCount,
    spin: state.completedTasksCount === state.tasksCount,
    locked: locked
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.milestoneInfo
  }, /*#__PURE__*/React.createElement(MilestoneInfo, {
    state: state
  })), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.lists, !state.canCompleteMilestone && styles.faded)
  }, lists.map(function (list) {
    return (
      // Remove once Milestones UI is revamped
      state.sessionStore.workspace.id !== '1' || list.tasks.length > 0 ? /*#__PURE__*/React.createElement(TaskList, {
        key: list.title,
        list: list
      }) : null
    );
  })), /*#__PURE__*/React.createElement(MilestoneCompletionModal, {
    state: state
  }));
};
export default observer(MilestonesView);
//# sourceMappingURL=index.js.map
